import React, { Component } from 'react';
import { connect } from 'react-redux';
import IntlMessages from 'util/IntlMessages';
import { getMeldooWebCaptcha, sendNewMeldooWebReport, resetNewMeldooWebReportResponse, getMeldooWebTypesByLocation } from 'actions/MeldooWeb';
import Location from './Component/Location';
import Types from './Component/Types';
import PersonalData from './Component/PersonalData';
import Summary from './Component/Summary';
import Steps, { Step } from 'rc-steps';
import 'rc-steps/assets/index.css';
import 'rc-steps/assets/iconfont.css';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import geolib from 'geolib';
import _ from 'lodash';
import SweetAlert from 'react-bootstrap-sweetalert';
import Geocode from 'react-geocode';
Geocode.setApiKey('AIzaSyBeDdj4XA0GQrGM16neBfzMSOPy49o0u5Q');
Geocode.enableDebug();

class NewReport extends Component {
	constructor(props) {
		super(props);
		this.state = {
			reportStep: 0,
			selectedPosition: null,
			selectedType: null,
			duplicates: [],
			description: '',
			firstName: '',
			lastName: '',
			email: '',
			phone: '',
			images: [],
			types: [],
			sendButtonDisabled: false,
			panTo: false,
			panToSearch: false,
			captchaInputValue: '',
			errorMessages: {
				position: false,
				type: false,
				description: false,
				firstName: false,
				lastName: false,
				email: false,
				phone: false,
				captcha: false
			}
		};
	}

	componentDidMount() {
		this.props.getMeldooWebCaptcha();
		//alert('test');
		//		window.scrollTo({ top: 0, behavior: 'smooth' });
		//		document.body.scrollTop = 0;
		//document.querySelector('body').scrollTop = 0;
	}

	getHouseNumber(address) {
		const streetNumber = address.find(element => element.types.find(type => type === 'street_number'));
		if (streetNumber) return streetNumber.long_name;
		return '';
	}

	getStreet(address) {
		const street = address.find(element => element.types.find(type => type === 'route'));
		if (street) return street.long_name;
		return '';
	}

	getZip(address) {
		const zip = address.find(element => element.types.find(type => type === 'postal_code'));
		if (zip) return zip.long_name;
		return '';
	}

	getCity(address) {
		const city = address.find(element => element.types.find(type => type === 'locality'));
		if (city) return city.long_name;
		return '';
	}

	getNeighborhood(address) {
		const neighborhood = address.find(element => element.types.find(type => type === 'sublocality'));
		if (neighborhood) return neighborhood.long_name;
		return '';
	}

	onSetPosition = selectedPosition => {
		this.setState({ panToSearch: true });
		this.onSelectPosition(selectedPosition);
	};

	onSelectPosition = selectedPosition => {
		// Prüfen ob die gewählte Position innerhalb des Polygon liegt.
		const { path } = this.props.settings.general;
		let positionInPolygon = false;
		this.setState({ panTo: false });

		const poly = path.map(pathA => {
			return {
				paths: pathA.map(pathB => {
					return pathB.map(coodinates => {
						return {
							latitude: coodinates.y,
							longitude: coodinates.x
						};
					});
				})
			};
		});

		const test2 = poly.map(areas =>
			areas.paths.map(polgons => {
				if (geolib.isPointInside({ latitude: selectedPosition.lat, longitude: selectedPosition.lng }, polgons)) {
					positionInPolygon = true;
					return true;
				}
			})
		);
		// Wenn keine Polgon benutzt werden soll ist die Position immer im Polygon
		if (!this.props.settings.general.mapRestrictedArea) {
			positionInPolygon = true;
		}
		if (positionInPolygon) {
			if (this.state.panToSearch) {
				this.setState({ panTo: true });
			}
			this.setState({ panToSearch: false, selectedPosition, errorMessages: { ...this.state.errorMessages, position: false } });
			this.setState({
				duplicates: _.sortBy(
					_.compact(
						this.props.reports.map(report => {
							const distance = geolib.getDistance(
								{ latitude: report.latlng.lat, longitude: report.latlng.lng },
								{ latitude: selectedPosition.lat, longitude: selectedPosition.lng },
								10,
								1
							);
							return distance <= 100 ? { ...report, distance } : null;
						})
					),
					['distance']
				)
			});
		} else {
			this.setState({ panToSearch: false, selectedPosition: null, errorMessages: { ...this.state.errorMessages, position: false } });
		}
	};

	checkRequiredFields = () => {
		const { name, email, phone, description } = this.props.settings.requirements;
		if (!this.state.description && description.required)
			return this.setState({ errorMessages: { ...this.state.errorMessages, description: true } });
		if (!this.state.firstName && name.required) return this.setState({ errorMessages: { ...this.state.errorMessages, firstName: true } });
		if (!this.state.lastName && name.required) return this.setState({ errorMessages: { ...this.state.errorMessages, lastName: true } });
		if (!this.state.email && email.required) return this.setState({ errorMessages: { ...this.state.errorMessages, email: true } });
		if (!this.state.phone && phone.required) return this.setState({ errorMessages: { ...this.state.errorMessages, phone: true } });
		this.setState({ reportStep: 3 });
	};

	sendNewReport = () => {
		const { name, email, phone, description } = this.props.settings.requirements;
		this.setState({ sendButtonDisabled: true });
		if (!this.state.selectedPosition)
			return this.setState({ sendButtonDisabled: false, reportStep: 0, errorMessages: { ...this.state.errorMessages, position: true } });
		if (!this.state.selectedType)
			return this.setState({ sendButtonDisabled: false, reportStep: 1, errorMessages: { ...this.state.errorMessages, type: true } });
		if (!this.state.description && description.required)
			return this.setState({ sendButtonDisabled: false, reportStep: 2, errorMessages: { ...this.state.errorMessages, description: true } });
		if (!this.state.firstName && name.required)
			return this.setState({ sendButtonDisabled: false, reportStep: 2, errorMessages: { ...this.state.errorMessages, firstName: true } });
		if (!this.state.lastName && name.required)
			return this.setState({ sendButtonDisabled: false, reportStep: 2, errorMessages: { ...this.state.errorMessages, lastName: true } });
		if (!this.state.email && email.required)
			return this.setState({ sendButtonDisabled: false, reportStep: 2, errorMessages: { ...this.state.errorMessages, email: true } });
		if (!this.state.phone && phone.required)
			return this.setState({ sendButtonDisabled: false, reportStep: 1, errorMessages: { ...this.state.errorMessages, phone: true } });
		if (!this.state.captchaInputValue)
			return this.setState({ sendButtonDisabled: false, errorMessages: { ...this.state.errorMessages, captcha: true } });
		// Adressdaten aus den Koordinaten auslesen

		let address;

		Geocode.fromLatLng(this.state.selectedPosition.lat, this.state.selectedPosition.lng)
			.then(
				response => {
					address = {
						zip: this.getZip(response.results[0].address_components),
						city: this.getCity(response.results[0].address_components),
						street: this.getStreet(response.results[0].address_components),
						houseNumber: this.getHouseNumber(response.results[0].address_components),
						neighborhood: this.getNeighborhood(response.results[0].address_components)
					};
					//				this.props.setNewReportAddressAttribute(address);
				},
				error => {
					console.error(error);
					this.setState({ sendButtonDisabled: false });
					return this.setState({ errorMessages: { ...this.state.errorMessages, position: true } });
				}
			)
			.then(response => {
				this.props.sendNewMeldooWebReport(
					this.props.organisationKey,
					{
						latlng: this.state.selectedPosition,
						typeId: this.state.selectedType,
						description: this.state.description,
						images: this.state.images,
						firstName: this.state.firstName,
						lastName: this.state.lastName,
						email: this.state.email,
						phone: this.state.phone,
						address: address
					},
					this.state.captchaInputValue
				);
			});
	};

	onCloseSuccessModal = () => {
		this.props.resetNewMeldooWebReportResponse();
		this.setState({
			reportStep: 0,
			selectedPosition: null,
			selectedType: null,
			duplicates: [],
			description: '',
			firstName: '',
			lastName: '',
			email: '',
			phone: '',
			images: [],
			types: [],
			captchaInputValue: '',
			errorMessages: {
				position: false,
				type: false,
				description: false,
				firstName: false,
				lastName: false,
				email: false,
				phone: false,
				captcha: false
			}
		});
		this.props.getMeldooWebCaptcha();
		this.props.history.push(`/meldoo-web/${this.props.organisationKey}`);
	};

	renderContent() {
		switch (this.state.reportStep) {
			case 0:
				return (
					<Location
						settings={this.props.settings}
						panTo={this.state.panTo}
						reports={this.props.reports}
						duplicates={this.state.duplicates}
						errorMessages={this.state.errorMessages}
						onSelectPosition={selectedPosition => this.onSelectPosition(selectedPosition)}
						onSetPosition={selectedPosition => this.onSetPosition(selectedPosition)}
						selectedPosition={this.state.selectedPosition}
						onNextStep={() => this.setState({ reportStep: 1 })}
						onPreviousStep={() => this.props.history.push(`/meldoo-web/${this.props.organisationKey}`)}
					/>
				);
			case 1:
				return (
					<Types
						settings={this.props.settings}
						organisationKey={this.props.organisationKey}
						duplicates={
							this.state.selectedType
								? this.state.duplicates.filter(report => report.type.id === this.state.selectedType)
								: this.state.duplicates
						}
						onNextStep={() => this.setState({ reportStep: 2 })}
						onPreviousStep={() => this.setState({ reportStep: 0 })}
						onSelectType={selectedType => this.setState({ selectedType, errorMessages: { ...this.state.errorMessages, type: false } })}
						selectedType={this.state.selectedType}
						errorMessages={this.state.errorMessages}
						windowWidth={this.props.width}
						selectedPosition={this.state.selectedPosition}
						getTypesByLocation={getTypesByLocation => this.props.getMeldooWebTypesByLocation(getTypesByLocation)}
					/>
				);
			case 2:
				return (
					<PersonalData
						settings={this.props.settings}
						onNextStep={this.checkRequiredFields}
						onPreviousStep={() => this.setState({ reportStep: 1 })}
						onUpdateFormProp={(prop, value) =>
							this.setState({
								[prop]: value,
								errorMessages: { ...this.state.errorMessages, [prop]: false }
							})
						}
						formProps={this.state}
						duplicates={this.state.duplicates.filter(report => report.type.id === this.state.selectedType)}
						errorMessages={this.state.errorMessages}
					/>
				);
			case 3:
				return (
					<Summary
						settings={this.props.settings}
						onPreviousStep={() => this.setState({ reportStep: 2 })}
						onNextStep={this.sendNewReport}
						data={this.state}
						duplicates={this.state.duplicates.filter(report => report.type.id === this.state.selectedType)}
						loading={this.props.loading}
						captcha={this.props.newReportCaptcha}
						newCatpcha={() => this.props.getMeldooWebCaptcha()}
						onCaptchaInputUpdate={captchaInputValue =>
							this.setState({
								captchaInputValue,
								errorMessages: { ...this.state.errorMessages, captcha: false }
							})
						}
						captchaInputValue={this.state.captchaInputValue}
						errorMessages={this.state.errorMessages}
					/>
				);
			default:
				return (
					<Location
						settings={this.props.settings}
						reports={this.props.reports}
						duplicates={this.state.duplicates}
						errorMessages={this.state.errorMessages}
						onSelectPosition={selectedPosition => this.onSelectPosition(selectedPosition)}
						selectedPosition={this.state.selectedPosition}
						onNextStep={() => this.setState({ reportStep: 1 })}
						onPreviousStep={() => this.props.history.push(`/meldoo-web/${this.props.organisationKey}`)}
					/>
				);
		}
	}

	render() {
		const breakPoint = 700;
		return (
			<div className="row">
				<SweetAlert
					show={this.props.sendNewReportSuccess ? true : false}
					success
					confirmBtnStyle={{
						backgroundColor: this.props.settings.colors.success.bg,
						color: this.props.settings.colors.success.font
					}}
					title={<IntlMessages id="meldooWeb.newReport.send.success.title" />}
					onConfirm={this.onCloseSuccessModal}
				>
					{this.props.sendNewReportSuccess}
				</SweetAlert>
				<SweetAlert
					show={this.props.sendNewReportError ? true : false}
					warning
					confirmBtnStyle={{
						backgroundColor: this.props.settings.colors.error.bg,
						color: this.props.settings.colors.error.font
					}}
					onConfirm={() => {
						this.setState({ sendButtonDisabled: false });
						this.props.resetNewMeldooWebReportResponse();
					}}
					title={<IntlMessages id="meldooWeb.newReport.send.error.title" />}
				>
					{this.props.sendNewReportError}
				</SweetAlert>
				{this.props.settings.modules.reportCollection && (
					<div className="col-12 mb-3">
						<div>
							<Breadcrumb className="mb-0 navigation-style" tag="nav">
								<BreadcrumbItem
									tag="span"
									className="pointer"
									onClick={() => this.props.history.push(`/meldoo-web/${this.props.organisationKey}`)}
								>
									<IntlMessages id="meldooWeb.reportCollection.title" />
								</BreadcrumbItem>
								<BreadcrumbItem active tag="span">
									<IntlMessages id="meldooWeb.newReport.title" />
								</BreadcrumbItem>
							</Breadcrumb>
						</div>
					</div>
				)}
				<div className="col-12">
					<div className="w-100" style={{ paddingRight: 36 }}>
						<Steps current={this.state.reportStep} direction="horizontal" labelPlacement="vertical">
							<Step icon={<i className="zmdi zmdi-pin zmdi-hc-lg" />} />
							<Step icon={<i className="zmdi zmdi-apps zmdi-hc-lg" />} />
							<Step icon={<i className="zmdi zmdi-info-outline zmdi-hc-lg" />} />
							<Step icon={<i className="zmdi zmdi-format-list-numbered zmdi-hc-lg" />} />
						</Steps>
					</div>
					{this.props.width > breakPoint && (
						<div className="d-flex justify-content-between" style={{ paddingLeft: 22, paddingRight: 22 }}>
							<div style={{ width: 110 }}>
								<IntlMessages id="meldooWeb.newReport.steps.position" />
							</div>
							<div style={{ width: 110, paddingLeft: 15 }}>
								<IntlMessages id="meldooWeb.newReport.steps.type" />
							</div>
							<div style={{ width: 110 }}>
								<IntlMessages id="meldooWeb.newReport.steps.additionalData" />
							</div>
							<div>
								<IntlMessages id="meldooWeb.newReport.steps.summary" />
							</div>
						</div>
					)}
				</div>
				<div className="col-12">{this.renderContent()}</div>
			</div>
		);
	}
}

function mapStateToProps({ meldooWeb, settings }) {
	const { loading, reports, newReportCaptcha, sendNewReportSuccess, sendNewReportError } = meldooWeb;
	const { width } = settings;
	return {
		settings: meldooWeb.settings,
		loading,
		reports,
		newReportCaptcha,
		sendNewReportSuccess,
		sendNewReportError,
		width
	};
}

export default connect(
	mapStateToProps,
	{ getMeldooWebCaptcha, sendNewMeldooWebReport, resetNewMeldooWebReportResponse, getMeldooWebTypesByLocation }
)(withRouter(NewReport));



// WEBPACK FOOTER //
// ./containers/MeldooWeb/Pages/NewReport/index.js